import EventHandler from '@pixelunion/events';
import Modal from '../components/Modal';

export default class StaticPassword {
  constructor({ el }) {
    this.events = new EventHandler();
    this.el = el;

    this.modal = new Modal();

    this.events.register(document.querySelector('[data-open-modal-button]'), 'click', () => this.openModal());

    if (document.querySelector('[data-open-modal]')) {
      this.openModal();
    }
  }

  openModal() {
    this.modal.open('.password-page-modal-content', 'password');
  }

  onSectionUnload() {
    this.events.unregisterAll();
    this.modal.unload();
  }
}
